// для принудительного ререндера всей странице по изменению key компоненты страницы роутера, когда это действительно нужно 
export default {
  data: () => ({
    keyPage: '',
  }),

  methods: {
    popstateEvent() {
      this.keyPage = `${this.$route.fullPath}_${Math.random()}`;
    },
  },

  mounted() {
    this.keyPage = this.$route.fullPath;

    window.addEventListener('popstate', this.popstateEvent);
  },

  beforeDestroy() {
    document.removeEventListener('popstate', this.popstateEvent);
  },
};
